export default __webpack_public_path__ + "static/media/TESLA.b367cc62.png";